export default __webpack_public_path__ + "static/media/Logo_US-mounted-PNG.b2fd8aa7.png";